import React from 'react';

export function ExternalImport() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.37539 10.6501C7.67539 10.6501 7.95039 10.4001 7.95039 10.0751V6.32514C7.95039 4.97514 9.05039 3.87514 10.4004 3.87514H13.3754L11.9254 5.25014C11.7004 5.47514 11.7004 5.82514 11.9004 6.05014C12.0004 6.17514 12.1504 6.22514 12.3004 6.22514C12.4504 6.22514 12.5754 6.17514 12.6754 6.07514L14.9754 3.90014C15.1254 3.75014 15.2254 3.52514 15.2254 3.30014C15.2254 3.07514 15.1254 2.87514 14.9754 2.72514L12.6754 0.600138C12.4504 0.400138 12.1004 0.400138 11.8754 0.625138C11.6754 0.850138 11.6754 1.20014 11.9004 1.42514L13.3504 2.77514H10.3504C8.37539 2.77514 6.77539 4.37514 6.77539 6.35014V10.1001C6.82539 10.4001 7.07539 10.6501 7.37539 10.6501Z"
        fill="white"
      />
      <path
        d="M14.7508 9.525C14.4508 9.525 14.1758 9.775 14.1758 10.1V13.725C14.1758 14.125 13.8508 14.45 13.4508 14.45H2.55078C2.15078 14.45 1.82578 14.125 1.82578 13.725V10.075C1.82578 9.775 1.57578 9.5 1.25078 9.5C0.925781 9.5 0.675781 9.75 0.675781 10.075V13.7C0.675781 14.725 1.50078 15.55 2.52578 15.55H13.4508C14.4758 15.55 15.3008 14.725 15.3008 13.7V10.075C15.3258 9.775 15.0758 9.525 14.7508 9.525Z"
        fill="white"
      />
    </svg>
  );
}
